//import React from 'react';
import DateTimePicker from 'react-datetime-picker';
import styled from 'styled-components';
import { fontFamily } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

import { Box } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label } from '../../../typography';
//import { ErrorMessage } from 'formik';

const DateTimePickerWrapper = styled.div<StyledSystemProps>`
  width: 100%;
  .react-date-picker,
  .react-daterange-picker {
    background-color: #fff;
    height: 40px;
    display: flex;
    font-weight: 400;
    border-radius: 4px;
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
  }
  .react-datetime-picker > .react-datetime-picker__wrapper {
    border-radius: 4px;
    border: 1px solid rgba(50, 50, 93, 0.2);
  }
  .react-calendar {
    border: 1px solid rgba(50, 50, 93, 0.2);
    border-radius: 4px;
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
    ${fontFamily};
    padding: 10px;
  }
`;

const DateTimePickerWithFormik = ({
  date,
  dateLabel,
  readOnly,
  form: { setFieldValue },
  label,
  changeHandler,
  format,
  ...rest
}: any) => {
  return (
    <Box {...rest}>
      {label !== undefined && <Label htmlFor={dateLabel}>{label}</Label>}
      <DateTimePickerWrapper>
        <DateTimePicker
          disabled={readOnly}
          value={date}
          format={format}
          onChange={(date: any) => {
            dateLabel && setFieldValue(dateLabel, date);
            if (changeHandler) changeHandler(date);
          }}
        />
      </DateTimePickerWrapper>
      {/* {dateLabel && (
        <ErrorMessage name={dateLabel}>
          {msg => (
            <Span mt={2} color="red" textAlign="right">
              {msg}
            </Span>
          )}
        </ErrorMessage>
      )} */}
    </Box>
  );
};

DateTimePickerWithFormik.defaultProps = {
  mb: 4,
  flex: 1,
  minWidth: '150px',
};

export default DateTimePickerWithFormik;
